import React, {Component} from 'react';
import { radius, tickWidth } from '../constants';
import { select, event } from 'd3-selection';
import {drag} from 'd3-drag';
import throttle from 'lodash.throttle';
import {scaleLinear} from 'd3-scale';
import { observer } from 'mobx-react';
import gameStyles from './game-style.scss.js';
@observer
class TunerSlider extends Component {
  constructor(props) {
    super(props);
    this.throttledPlay = throttle(this.props.playSelected, 300);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.isFirstDrag = true;
  }
  dragged(that) {
    //make sure it's in a valid location
    if (this.isFirstDrag && Math.abs(event.dy) < 2) {
      this.isFirstDrag = true;
      return;
    }
    let nextY;
    if (event.y <= radius) {
      nextY = radius;
    }
    else if (event.y >= this.props.height - radius) {
      nextY = this.props.height - radius;
    }
    else {
      nextY = event.y;
    }
    select(that).attr("transform", `translate(${this.props.width/2},${nextY})`);
    // use this.scale to set pitch
    const pitch = this.scale(nextY);
    this.throttledPlay(pitch);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.height !== nextProps.height) {
      this.updateDimensions(nextProps.height);
    }
    if (this.props.correctCount < nextProps.correctCount) {
          select('.drag-circle').transition()
        .attr("transform", `translate(${this.props.width/2},${this.props.height/2.0})`);
    }
  }
  componentWillMount() {
    const height = this.props.height;
    this.scale = scaleLinear().domain([radius,height-radius])
      .range([this.props.range, -1*this.props.range]).clamp(true);
  }
  componentDidMount() {
    this.updateDimensions(this.props.height);
  }
  updateDimensions(height) {
    this.scale = scaleLinear().domain([radius,height-radius])
      .range([this.props.range, -1*this.props.range]).clamp(true);
    const that = this;
    select(".drag-circle").call(
      drag()
        .on("drag", function() { that.dragged(this); })
        .on("end", function() {
          //also play on touchend
          that.isFirstDrag = true;
          const string = select(this).attr("transform");
          const translate = string.substring(string.indexOf("(")+1, string.indexOf(")")).split(",");
          that.dragged(this);
          const spaces = (translate[1] - radius) / that.tickSpacing;
          const intervalsToMoveTo = Math.round(spaces);
          const nextY = that.tickSpacing*intervalsToMoveTo + radius;
          //always call move
          select(this).transition()
            .attr("transform", `translate(${that.props.width/2},${nextY})`);
          const pitch = that.scale(nextY);
          //use throttled pitch call, mislabeled here
          that.throttledPlay(pitch);
        })
    );
  }
  render() {
    const animateString = this.props.deTunedSamplers[this.props.selectedIndex].isPlaying? `circle-under-${this.props.selectedIndex}` : "";
    const colorClass = `selected-circle-${this.props.selectedIndex}`;
    const height = this.props.height;
    const width = this.props.width;
    let startOfTicks = radius;
    // cut the rendered area into length-1 regions (fenceposting)
    // calculate pixel space
    const count = this.props.items.length;
    const space = (height - 2*radius) / (count-1);
    this.tickSpacing = space;
    //how wide to draw ticks
    const startX = (width / 2.0)- tickWidth / 2.0;
    const endX = (width / 2.0) + tickWidth / 2.0;
    const ticks = this.props.items.map( (_item, ind) => {
      let thisY = startOfTicks + ind*space;
      return <line key={ind}
        x1={startX}
        y1={thisY}
        x2={endX}
        y2={thisY}
        strokeWidth="2"
        stroke="black"
      />
    });
    return (
      <g style={this.props.groupStyle}>
        <g className="line-master">
          <line x1={this.props.width / 2.0}
            y1={radius}
            x2={this.props.width / 2.0}
            y2={this.props.height - radius}
            strokeWidth="2"
            stroke="black"
          />
          {ticks}
        </g>
        <g className="slider-circle-master">
          <g className="drag-circle"
            transform={`translate(${this.props.width/2},${this.scale
                .invert(this.props.deTunedSamplers[this.props.selectedIndex].currentUIOffset)})`}>
            <circle r={radius} cx={0}
              className={`circles ${colorClass} ${animateString}`}
              cy={0}
              style={{...gameStyles.circle, ...gameStyles.selected}}
            />
            <circle r={radius} cx={0}
              className={`circles ${colorClass}`}
              cy={0}
              style={{...gameStyles.circle, ...gameStyles.selected}}
            />
          </g>
        </g>
      </g>
    );

  }
}
export default TunerSlider;



// WEBPACK FOOTER //
// ./src/components/tuner-slider.js